import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import EvaluationPage from './pages/EvaluationPage';
import ResultsPage from './pages/ResultsPage';
import HistoryPage from './pages/HistoryPage';
import { BreadEvaluationProvider } from './context/BreadEvaluationContext';
export function App() {
  return <BreadEvaluationProvider data-id="element-0">
      <Router data-id="element-1">
        <div className="min-h-screen bg-gray-100" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
            <Route path="/evaluation" element={<EvaluationPage data-id="element-7" />} data-id="element-6" />
            <Route path="/results" element={<ResultsPage data-id="element-9" />} data-id="element-8" />
            <Route path="/history" element={<HistoryPage data-id="element-11" />} data-id="element-10" />
          </Routes>
        </div>
      </Router>
    </BreadEvaluationProvider>;
}